import React from 'react';
import Loader from '@ey/canvascoreservices/LoadingIndicator';
import styled from 'styled-components';

export default function LoadingIndicator(props) {
	const {show, fullscreen, view, styleName} = props;
	return <StyledMotifLoader {...props} show={show} fullscreen={fullscreen} className={view + ' ' + styleName} />;
}

const StyledMotifLoader = styled(Loader)`
	&.motif-progress-loader-container {
		&.inlineView {
			padding: 1rem 0;
			align-items: unset;
			background: transparent;
			height: auto;
			position: relative;
		}

		&.blockView {
			height: 100%;
			width: 100%;
			background-color: rgba(246, 246, 250, 0);
			position: relative;
		}

		&.inFrontView {
			z-index: 101;
		}
		.motif-loader-content {
			.motif-loader-square {
				width: 1.6rem;
				height: 1.6rem;
			}
		}
	}
`;
